import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type { ForumDropDownOption } from 'bundles/discussions/components/forumsV2-ForumDropDown';
import { ForumDropDownWithTheme } from 'bundles/discussions/components/forumsV2-ForumDropDown';
import type { Forum } from 'bundles/discussions/lib/types';
import { getForumLink } from 'bundles/discussions/utils/discussionsUrl';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

type Props = {
  courseForums: OnDemandCourseForumsV1[];
  courseSlug: string;
  currentForum: Forum;
  selectedIndex?: number;
  skipTheme?: boolean;
  param: 'forum' | 'subForum_id' | 'forum_id';
  onChange?: (forum: Forum, sort: string, pageNum: number, filterQueryString: string) => void;
  unsetOption?: ForumDropDownOption<string, string>;
  ariaLabelPrefix?: string;
};

type State = {
  label?: string;
};
class TopLevelForumsDropDown extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof TopLevelForumsDropDown.contextTypes>;

  static state = {
    label: undefined,
  };

  constructor(props: $TSFixMe) {
    super(props);
    this.state = { label: this.context?.router?.location?.query[this.props.param] };
  }

  getSelectedLabel = () => {
    const urlParamValue = this.context?.router?.location?.query[this.props.param];
    for (let i = 0; i < this.props.courseForums.length; i += 1) {
      if (this.props.courseForums[i].id === urlParamValue) {
        return this.props.courseForums[i].title;
      } else if (this.props.selectedIndex) {
        return (
          this.props.courseForums[this.props.selectedIndex] && this.props.courseForums[this.props.selectedIndex].title
        );
      }
    }
    return undefined;
  };

  getForumLink = (forum: $TSFixMe) => {
    const newLink = getForumLink(forum.forumId);
    return newLink;
  };

  getForumOption = (forum: Forum): ForumDropDownOption<string, string> => {
    return { label: forum.title, param: this.props.param, value: forum.id, forum };
  };

  getForumsOptions = (subForums: $TSFixMe): ForumDropDownOption<string, string>[] => {
    let result: ForumDropDownOption<string, string>[] = [];
    if (subForums) {
      result = subForums.map(this.getForumOption);
      if (this.props.unsetOption) {
        result = [this.props.unsetOption, ...result];
      }
    }
    return result;
  };

  hasOptions = (options: $TSFixMe) => {
    const optionMinimumLength = this.props.unsetOption ? 2 : 1;
    return Array.isArray(options) && options.length >= optionMinimumLength;
  };

  render() {
    const options = this.getForumsOptions(this.props.courseForums);

    if (!this.hasOptions(options)) {
      return null;
    }

    const label = this.getSelectedLabel();
    const style = this.props.skipTheme ? undefined : { fontWeight: 600, fontSize: '20px', width: 'max-content' };

    return (
      <ForumDropDownWithTheme
        ariaLabelPrefix={this.props.ariaLabelPrefix}
        options={options}
        style={style}
        selectedLabel={label || this.state?.label}
        onChange={(option: ForumDropDownOption<string, string>) => {
          if (this.props.onChange && option.forum) {
            this.props.onChange(option.forum, 'asc', 1, '');
            this.setState({ label: option.label });
            this.context.router.push(this.context.router.location.pathname + '?' + option.param + '=' + option.value);
          } else {
            this.context.router.push(this.getForumLink(option.forum) + '?' + option.param + '=' + option.value);
          }
        }}
      />
    );
  }
}

export default TopLevelForumsDropDown;
